import React from "react";
import { useModalContext } from "../../contexts/ModalContext/context";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import { Button } from "../../UI/Button";
import {ImportMigrationModal} from "../ImportMigrationModal";

export const ImportMigrationButton = () => {
  const { setIsOpen } = useModalContext();
  const { selectedNetworkId } = useSelectedNetworkContext();

  const handleClick = () => setIsOpen(true);

  return (
    <>
      <Button appearance="danger" isDisabled={!selectedNetworkId} onClick={handleClick}>
        Migrate Import
      </Button>
      <ImportMigrationModal/>
    </>
  );
};
